export function isWeixin () {
  let ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('MicroMessenger') > -1 ||
    ua.indexOf('micromessenger') > -1) {
    return true
  } else {
    return false
  }
}
export function ismaoyanBoole () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('maoyan') > -1 ||
    ua.indexOf('maoyan') > -1) {
    return true
  } else {
    return false
  }
}

// IPhoneX 判断
export function phoneXIs () {
  var u = navigator.userAgent
  if ((u.indexOf('iPhone') > -1 || u.indexOf('maoyan') > -1)) {
    if ((screen.width === 414 && screen.height === 896) ||
      (screen.width === 375 && screen.height === 812)) {
      return true
    }
  }
  return false
}
// IPhoneX 判断
export function iphone () {
  var u = navigator.userAgent
  if (u.indexOf('iPhone') > -1) {
    return true
  }
  return false
}

// 判断移动端
export function phoneIs () {
  var browser = navigator.userAgent.toLowerCase()
  var phone = /iphone|ipod|ipad|android|mobile|blackberry|webos|incognito|webmate|bada|nokia|lg|ucweb|skyfire|micromessenger/i
  if (phone.test(browser)) {
    return true
  }
  return false
}
export function getNumberPrice (number) {
  if (number > 10000) {
    return (number / 10000).toFixed(1) + '万'
  } else {
    return number
  }
}
